export default "__VITE_ASSET__B_yB3F3x__"